var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"interface"},[_c('section',{staticClass:"title"},[_c('h1',[_c('i',{staticClass:"icon-deconnexion"}),_vm._v("LOGOUT")])])])}]

export { render, staticRenderFns }